import axios from "axios";

const ENV_URL = process.env.REACT_APP_API_URL;

const formatNumber = (num) => (num < 10 ? `0${num}` : (num));

export const getPanelResume = async ({ token, date, cpf }) => {
  console.log("🚀 ~ getPanelResume ~ date:", date)
  const actualMonth = new Date().getMonth() + 1;
  const actualYear = new Date().getFullYear();
  const URL = `${ENV_URL}/companyDashboard/analyze${cpf ? "/" + cpf : ""
    }?date=${date ? date : `${actualYear}-${formatNumber(actualMonth)}`}`;
  try {
    const { data } = await axios({
      method: "GET",
      url: URL,
      headers: {
        authorization: token || "",
      },
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getDashboardPermisions = async ({ actToken, id }) => {
  const URL = `${ENV_URL}/companyDashboard/permissions/${id}`;
  try {
    const { data } = await axios({
      method: "GET",
      url: URL,
      headers: {
        authorization: actToken || "",
      },
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};

export const getDateFilter = async (token) => {
  const URL = `${ENV_URL}/companyDashboard/filterdata`;
  try {
    const { data } = await axios({
      method: "GET",
      url: URL,
      headers: {
        authorization: token || "",
      },
    });
    return data;
  } catch (err) {
    console.log(err);
    throw err;
  }
};
